<template>
  <div>
      <!-- <iframe :src="url" style="border: none" :height="height + 30" width="100%"></iframe> -->
      <div  style="width: 100%;height: 100%; background-color: black;" :height="height + 30"></div>
  </div>
</template>

<script>
import $http from '../video-request';
import $httpaqsc from '../request';
export default {
  props: {
    sxtbm: {
      type: String,
      default: '',
    },
    startToPlay: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 200,
    }
  },
  data() {
    return {
      // tenantId: sessionStorage.getItem("tenantId"),
      tenantId: "demo",
      timer: null,
      url: ''
    };
  },
  watch: {

  },
  created() {

  },
  mounted() {
     this.getVideoUrl();
  },
  methods: {
    getVideoUrl() {
      setTimeout(this.end(),4000);
      // 初始化调用视频解析接口
      $http({
        url: "ffmpegProcess/startToProcess/"+this.tenantId+"/"+this.sxtbm,
        method: 'get',
      }).then((res) => {
        console.log("我进来喽")
        // 调用视频画面
      })
      this.timer = setInterval(this.timeMthod, 15000);
    },
    end(){
      $httpaqsc({
        url: "hls2Video/realConfig",
        method: 'get',
      }).then((res) => {
        let videoUrl = res.data.videoUrl;
        this.url = videoUrl + `ffmpegPlay.html?tenantId=${this.tenantId}&key=${this.sxtbm}&height=${this.height + 'px'}`
      })
    },
    timeMthod(){
       // 重复杀掉进程录入视频画面
        $http({
            url: "ffmpegProcess/resetSetProcess/"+this.tenantId+"/"+this.sxtbm,
            method: 'get',
          }).then((res) => {
            console.log(res)
          })
  },
  },
  beforeDestroy() {
      console.log("清除")
      clearInterval(this.timer);
      $http({
            url: "ffmpegProcess/kllVideo/"+this.tenantId+"/"+this.sxtbm,
            method: 'get',
            }).then((res) => {
              console.log("清除2")
            })
    },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/video/AliPlayerHls2.vue